module.exports = __webpack_public_path__ + "assets/img/passat.c34cdd51.png";